import { AfterViewInit, Component, ContentChildren, OnInit, QueryList, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatorService } from '../../../shared/services/utils/translator.service';
import { ModalsHandlerService } from '../modals.handler.service';
import { LeadIdInput } from './../../../shared/models/lead/leadId.input';
import { LeadService } from './../../../shared/services/lead/lead.service';

@Component({
  selector: 'ngx-potencial-sellers-modal',
  templateUrl: './potencial-sellers-modal.component.html',
})
export class PotencialSellersModalComponent implements OnInit, AfterViewInit {

  @ViewChild('content', { static: false }) content: Element;
  @ContentChildren('a', { descendants: true }) links: QueryList<any>;
  loadingData = true;
  potencialSellers: any;
  title: string;

  constructor(
    private readonly modalService: NgbModal,
    private readonly modalsHandler: ModalsHandlerService,
    private readonly translator: TranslatorService,
    private readonly leadService: LeadService,
  ) { }
  ngAfterViewInit(): void {
    this.modalsHandler.potentialSellersModal.subscribe(leadId => {

      this.open();

      const leadIdInput = new LeadIdInput();
      leadIdInput.leadId = leadId;

      this.leadService.getPotentialSellers(leadIdInput).subscribe(res => {
        this.potencialSellers = res.potentialSellers;
        this.loadingData = false;
      });
    });

    this.modalsHandler.simulatedPotentialSellersModal.subscribe(simulatedPotentialSellers => {
      this.open();

      this.potencialSellers = simulatedPotentialSellers.potentialSellers;
      this.loadingData = false;
    });
  }

  private open() {
    this.modalService
      .open(this.content, {
        size: 'lg',
        container: 'nb-layout',
        ariaLabelledBy: 'modal-basic-title',
        backdrop: 'static', keyboard: false,
        backdropClass: 'app-session-modal-backdrop',
        windowClass: 'app-session-modal-window'
      }).result.finally(() => {
        this.potencialSellers = [];
      });
  }

  ngOnInit(): void {
    this.title = this.translator.trans('pages.leads.potencial_sellers');
  }
}
